import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import StoryTrialInput from '@/utvStore/components/Trial/StoryTrialInput'
import { FORM_DATA } from '@/CONSTS'
import fetchAccountData from '@/utils/fetchAccountData'
import GuestTemporaryInput from '@/utils/GuestTemporaryInput'

export default {
  name: 'story-trial',
  components: {
    StoryTrialInput
  },
  data:() => ({
    isLoading: false,
    errorMessage: null,
    displayNickname: '', // 結果表示用のニックネーム
    self: FORM_DATA.self,
    target: FORM_DATA.target
  }),
  props: {
    action: { type: String },
    method: { type: String, default: 'post' },
    itemsId: { type: String, required: true },
    itemName: { type: String, default: '' },
    inputParam: { type: Object, required: true },
    isFree: { type: Boolean, default: true },
    url: { type: String, default: '' },
    hiddenParam: {
      type: Object,
      default:() => ({})
    }
  },
  beforeMount() {
    // 必要パラメータの入力欄のみ表示
    let requiredFields = Object.keys(this.inputParam)
    Object.keys(this.self).forEach(key => {
      if (requiredFields.indexOf(key) === -1 || key in this.hiddenParam) {
        this.$delete(this.self, key)
      }
    })
    Object.keys(this.target).forEach(key => {
      if (requiredFields.indexOf(key) === -1 || key in this.hiddenParam) {
        this.$delete(this.target, key)
      }
    })

    if (this.isLoggedIn) {
      // ログイン済みの場合はuser/infoからユーザーデータを取得する
      let inputs = [this.self, this.target]
      fetchAccountData.getProfile(this.accessToken).then(res => {
        inputs.forEach(input => {
          for (let key in input) {
            if (key.includes('birthtime')) {
              let unknownColumnName = input[key].unknownName
              input[key].value = {
                value: res[key],
                unknown: res[unknownColumnName] === null ? 1 : Number(res[unknownColumnName])
              }
            } else {
              input[key].value = res[key]
            }
          }
        })
      }, this.$store)
    } else {
      // 未ログインの場合はsessionStorageから情報取得
      let inputs = [this.self, this.target]
      const tmpData = GuestTemporaryInput.data
      inputs.forEach(input => {
        for (let key in input) {
          if (key in tmpData) {
            if (key.includes('birthtime')) {
              Object.assign(input[key].value, tmpData[key])
            } else {
              input[key].value = tmpData[key]
            }
          }
        }
      })
    }
  },
  mounted() {
    this.$store.dispatch(type.RESET_TRIAL_RESULT)
  },
  computed: {
    ...mapState({
      results: state => state.trial.result,
      accessToken: state => state.auth.accessToken
    }),
    ...mapGetters(['hasTrialResult', 'isLoggedIn']),
    shareUrl() {
      return {
        line() {
          return `http://line.me/R/msg/text/?${this.snsShareLine}`
        },
        twitter() {
          return `http://twitter.com/share?url=${this.url}`
        },
        facebook() {
          return `http://www.facebook.com/share.php?u=${this.url}`
        }
      }
    }
  },
  methods: {
    // Google Analyticsに無料お試し占い利用のイベントを送信
    sendEvent() {
      window.gtag('event', 'PlayText', {
        custom_map: { dimension3: 'cpno' },
        cpno: window.Laravel.cpno
      })
    },

    // 入力トリガーのイベント
    updateInput(key, field) {
      // sessionStorageへ値を保存する
      const value = field.value
      if (GuestTemporaryInput.data) {
        let data = Object.assign({}, GuestTemporaryInput.data)
        Object.assign(data, { [key]: value })
        GuestTemporaryInput.data = data
      }
    },

    // 占うボタン押下時のイベント処理
    handleSubmit() {
      this.sendEvent()
      //On button pressed run validation
      this.$validator.validateAll().then(result => {
        if (result === false) {
          const errors = this.$validator.errors.items
          const $errorsElm = $(`[data-vv-id="${errors[0].id}"]`)
          $('html, body').animate(
            {
              scrollTop: $errorsElm[0] ? $errorsElm.offset().top - 80 : 0
            },
            300
          )
        } else {
          this.getTrialResult()
        }
      })
    },

    // APIに送信するPOSTデータの整形を行う
    createPostData() {
      const data = {}
      $(this.$refs.form)
        .serializeArray()
        .forEach(item => {
          Object.assign(data, { [item.name]: item.value })
        })
      Object.assign(data, { items_id: this.itemsId })
      return data
    },

    // 無料占いの結果を取得する
    getTrialResult() {
      const data = this.createPostData()
      this.isLoading = true
      this.$store.dispatch(type.RESET_TRIAL_RESULT)
      this.$store
        .dispatch(type.GET_TRIAL_RESULT, data)
        .then(this.renderTrialResult)
        .catch(this.onTrialError)
        .finally(() => {
          this.isLoading = false
        })
        /*
        $("meta[property='og:url']").attr('content', results.ogp_url)
        $("meta[property='twitter:url']").attr('content', results.ogp_url)
        $("meta[property='og:image']").attr('content', results.ogp_img)
        $("meta[property='twitter:image']").attr('content', results.ogp_img)
        */
    },

    // 無料占いの非同期結果取得成功時に行う描画処理
    renderTrialResult() {
      this.displayNickname = this.self.nickname.value
      this.errorMessage = false
      // 結果表示エリアまでスクロールする
      const $resultArea = $(this.$refs.resultArea)
      $('html, body').animate(
        {
          scrollTop: $resultArea.offset().top - 80
        },
        300
      )
    },

    // 無料占いの非同期結果取得失敗時に行う描画処理
    onTrialError(error) {
      if (error) {
        this.errorMessage = error.message
      }
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/Trial/mixins.js